import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Blog() {
    const { t, i18n } = useTranslation();
    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        fetch("https://ligasos-laravel.ligasos.co/api/blogs")
            .then((response) => response.json())
            .then((data) => setBlogs(data))
            .catch((error) => console.error("Error fetching blogs:", error));
    }, []);

    const isArabic = i18n.language === "ar";

    const showData = blogs.map((el) => (
        <div
            key={el.id}
            className="w-100 w-[32%] rounded-[8px] shadow-[0px_0px_10px_#00000038]"
        >
            <div className="w-full h-[360px]">
                <img
                    className="w-full h-full object-cover rounded-t-[8px]"
                    src={`https://ligasos-laravel.ligasos.co/storage/app/public/${el.image}`}
                    alt={`blog-${el.id}`}
                />
            </div>
            <div className="flex flex-col justify-between gap-[15px] p-[20px]">
                <div className="flex flex-col gap-[5px]">
                    <div className="font-bold text-[22px] capitalize">
                        {t(isArabic ? el.title_ar : el.title_en)}
                    </div>
                    <p>
                        {t(
                            isArabic
                                ? el.details_ar.length > 75
                                    ? el.details_ar.substring(0, 75) + "..."
                                    : el.details_ar
                                : el.details_en.length > 75
                                ? el.details_en.substring(0, 75) + "..."
                                : el.details_en
                        )}
                    </p>
                </div>
                <Link to={`/blogDetails/${el.id}`} className="w-fit flex flex-col">
                    <div className="font-bold capitalize text-[#0B2C3D]">{t("Read More")}</div>
                    <img
                        className="h-[3px]"
                        src={require("../../assets/icons/line-text.svg").default}
                        alt=""
                    />
                </Link>
            </div>
        </div>
    ));

    return (
        <>
            <section className="blog-landing">
                <div className="container relative h-full flex flex-col items-center justify-center">
                    <div>
                        <div className="btmAni2000 font-bold text-white text-[40px] capitalize">
                            {t("Important Topics")}
                        </div>
                    </div>
                </div>
            </section>

            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[40px]">
                    <div className="btmAni20002 flex flex-col gap-[3px]">
                        <div className="text-[30px] font-bold text-[#0B2C3D]">{t("Blogs")}</div>
                        <img
                            className="h-[3px]"
                            src={require("../../assets/icons/line-text.svg").default}
                            alt=""
                        />
                    </div>
                    <div className="f-col flex flex-wrap gap-[20px] justify-between">
                        {showData}
                    </div>
                </div>
            </section>
        </>
    );
}